import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalConstants } from 'src/app/constant/constant';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-privacy-policy-page',
  templateUrl: 'privacy-policy.page.html',
  styleUrls: [
    'privacy-policy.page.scss'
  ]
})

export class PrivacyPolicyPage {
  isPrivacyAccepted: boolean;

  constructor(
    public router: Router,
    public authService: AuthService
  ) {
    this.isPrivacyAccepted = JSON.parse(localStorage.getItem(GlobalConstants.IS_PRIVACYACCEPTED)) ?? false;
  }

  acceptPrivacy() {
    this.isPrivacyAccepted = true;
    localStorage.setItem(GlobalConstants.IS_PRIVACYACCEPTED, JSON.stringify(this.isPrivacyAccepted));
    this.closePrivacy();
  }

  closePrivacy() {
    if (this.isPrivacyAccepted) {
      this.router.navigate(['app/home']);
    } 
    else {
      this.authService.logout();
      this.router.navigate(['auth/login'], { replaceUrl: true });
    }
  }
}